import {api} from '@/core/services/api';

export default {
	methods: {
		async loadUnitConfiguration(id) {
			try {
				const unitConfiguration = (await api.get(`/getConfiguration/${id}`)).data.result;
				this.$store.commit('unitConfiguration/setUnitConfiguration', unitConfiguration);
			} catch (e) {
				console.error(e);
			}
		},
	},
};
